export default __webpack_public_path__ + "static/media/contact-list.b5ea4f5b.svg";